import { Dialog, FormInput } from "@/components"
import { ResetPasswordProps } from "./types";
import useResetPassword from "./useResetPassword";
import { FormProvider } from "react-hook-form";
import { CONFIRM_PASSWORD, NEW_PASSWORD } from "./consts";

const ResetPassword = ({open, setOpen, selectedUser}: ResetPasswordProps) => {
  const { form, onEyeIconClick, Icon, isPassword, requiredFields,
    onSubmit, isResetPasswordPending
  } = useResetPassword({selectedUser, setOpen});
  const { errors } = form.formState;

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={
        <div className="w-full text-center">
          <span className="text-2xl font-semibold text-gray-900">
            Reset Password
          </span>
        </div>
      }
      saveText="Reset"
      onSave={form.handleSubmit(onSubmit)}
      isLoading={isResetPasswordPending}
    >
      <FormProvider {...form}>
        <form>
          <div className="grid grid-cols-1 gap-4">
            <FormInput
              name={NEW_PASSWORD}
              control={form.control}
              label="New Password"
              placeholder="Please enter"
              error={errors[NEW_PASSWORD]?.message}
              isRequired={requiredFields.includes(NEW_PASSWORD)}
              type={isPassword["newPassword"] ? "password" : "text"}
              endIcon={
                <Icon
                  className="h-4 w-4"
                  onClick={onEyeIconClick("newPassword")}
                />
              }
            />
            <FormInput
              name={CONFIRM_PASSWORD}
              control={form.control}
              label="Confirm Password"
              placeholder="Please enter"
              error={errors[CONFIRM_PASSWORD]?.message}
              isRequired={requiredFields.includes(CONFIRM_PASSWORD)}
              type={isPassword["confirm"] ? "password" : "text"}
              endIcon={
                <Icon
                  className="h-4 w-4"
                  onClick={onEyeIconClick("confirm")}
                />
              }
            />
          </div>
        </form>
      </FormProvider>
    </Dialog>
  ) 
}

export default ResetPassword;